<template>
  <div class="gray-back" style="padding:.2rem 0 1.2rem 0;height: auto">
    <van-form
        @submit="onSubmit"
        @failed="onFailed"
    >
      <van-cell-group>
        <van-cell title="单位名称" :value="formData.danwei"  />
       
        <div class="operate-desc-left">证书生成的单位名称以此处填报的单位名称为准</div>

        <van-field
            readonly
            clickable
            input-align="right"
            label="队伍信息"
            v-model="formData.sai_baoming_name"
            :rules="[{ required: true, message: '请选择队伍报名记录' }]" 
             @click="showBaomimgPicker=true"
            placeholder="请选择队伍报名记录"
        />   
        <van-field
            readonly
            clickable
            input-align="right"
            label="项目信息"
            v-model="formData.sai_baoming_subject_name"
            :rules="[{ required: true, message: '请选择队伍项目' }]"  
             @click="showBaomimgSubjectPicker=true"
            placeholder="请选择队伍项目"
        />   
 
        <van-field
            readonly
            clickable
            input-align="right"
            label="考试星级"
            placeholder="请选择考试星级"
        /> 
        <div class="row" >
          <van-checkbox-group v-model="formData.star_type" direction="horizontal">
            <van-checkbox  :key="item.id" :name="item" v-for="item in starList" style="margin-bottom: 5px"
                          checked-color="rgb(255, 173, 25)">{{ item.text }}
            </van-checkbox>
          </van-checkbox-group>
        </div>

        <van-field
            readonly
            clickable
            name="area"
            :value="formData.province?formData.province+'/'+formData.city+'/'+formData.county:''"
            input-align="right"
            label="省市地区"
            placeholder="点击选择省市区"
            @click="showArea = true"
        />
        <van-popup v-model="showArea" position="bottom">
          <van-area
              :area-list="areaList"
              :value="formData.area"
              @confirm="onAreaConfirm"
              @cancel="showArea = false"
          />
        </van-popup>
        <van-field
            v-if="false"
            readonly
            clickable
            right-icon="arrow"
            name="area"
            input-align="right"
            label="本机构考官"
            placeholder="请选择人员"
            @click="onKaoguanShow"
        />
        <div class="operate-desc-left" 
            v-if="false">本机构考官选填</div>
        <van-tag
            v-for="(kaoguan ,index) in formData.jigoukaoguan"
            :key="index"
            size="large"
            plain
            closeable
            type="primary"
            @close="formData.jigoukaoguan.splice(index,1)"
        > {{ kaoguan.name }}({{ kaoguan.grade }}) <a :href="'tel:'+kaoguan.phone">{{ kaoguan.phone }}</a>
        </van-tag>

        
        <van-field
            v-if="false"
            v-model="formData.address"
            :rules="[{ required: true, message: '请输入考级地址' }]"
            error-message-align="right"
            label="考级地址"
            input-align="right"
            clearable
            placeholder="请输入考级地址"
        />

        <van-field
            v-if="false"
            name="kaoguan"
            label="非机构考官"
            readonly
            clickable
        >
          <template #button>
            <div class="small-button" @click="getKaoguanRand">{{ kaoguanWaitList.length > 0 ? '更换一波' : '随机筛选' }}</div>
          </template>
        </van-field>

        <div class="kaoguan-box" 
            v-if="false">
          <div style="border-top: 1px solid #eeee;padding: 10px 0 10px 10px;">已选考官名单</div>
          <van-tag
              v-for="(kaoguan ,index) in formData.kaoguan"
              :key="index"
              size="large"
              plain
              closeable
              type="primary"
              @close="formData.kaoguan.splice(index,1)"
          > {{ kaoguan.name }}({{ kaoguan.grade }}) <a :href="'tel:'+kaoguan.phone">{{ kaoguan.phone }}</a>
          </van-tag>
        </div>

        <div class="kaoguan-box" v-if="kaoguanWaitList.length > 0">
          <div style="border-top: 1px solid #eeee;padding: 10px 0 10px 10px;">待选考官</div>
          <van-tag
              v-for="(kaoguan ,index) in kaoguanWaitList"
              :key="index"
              size="large"
              plain
              type="primary"
          > {{ kaoguan.name }}({{ kaoguan.grade }}) <span>{{ kaoguan.phone }}</span>
            <div class="small-button" style="margin-left: 5px" @click="onKaoguanChoose(kaoguan)">选择</div>
          </van-tag>
        </div>

        <van-field
            v-if="false"
            name="jiandu"
            label="监督选择"
        >
          <template #button>
            <div class="small-button" type="default" @click="getJianduRand">
              {{ formData.jiandu.length > 0 ? '更换一波' : '随机筛选' }}
            </div>
          </template>
        </van-field>
        <!--        <van-field-->
        <!--            readonly-->
        <!--            clickable-->
        <!--            right-icon="arrow"-->
        <!--            name="area"-->
        <!--            input-align="right"-->
        <!--            label="监督选择"-->
        <!--            placeholder="请选择人员"-->
        <!--            @click="showJianduPicker = true"-->
        <!--        />-->
        <div class="row" 
            v-if="false">
          <van-tag
              v-for="(jiandu ,index) in formData.jiandu"
              :key="index"
              size="large"
              plain
              closeable
              type="primary"
              @close="formData.jiandu.splice(index,1)"
          > {{ jiandu.name }} <a :href="'tel:'+jiandu.phone">{{ jiandu.phone }}</a>
          </van-tag>
        </div>
        <!--        <van-field-->
        <!--            readonly-->
        <!--            clickable-->
        <!--            right-icon="arrow"-->
        <!--            name="area"-->
        <!--            input-align="right"-->
        <!--            label="考级中心授权"-->
        <!--            placeholder="请选择考级中心"-->
        <!--            @click="showCenterPicker = true"-->
        <!--        />-->
        <!--        <div class="row">-->
        <!--          <van-tag-->
        <!--              v-for="(center ,index) in formData.extra_center"-->
        <!--              :key="index"-->
        <!--              size="large"-->
        <!--              plain-->
        <!--              closeable-->
        <!--              type="primary"-->
        <!--              @close="formData.extra_center.splice(index,1)"-->
        <!--          > {{ center.name }}-->
        <!--          </van-tag>-->
        <!--        </div>-->
        <!--        <div class="operate-desc-left">考级点如需申报绿星级及以上星级的考级，需要获得考级中心授权</div>-->
        <van-field
            v-model="formData.name"
            :rules="[{ required: true, message: '请输入日常联系人姓名' }]"
            error-message-align="right"
            label="联系人姓名"
            rows="1"
            autosize
            type="textarea"
            input-align="right"
            clearable
            placeholder="请输入日常联系人姓名"
        />
        <van-field
            v-model="formData.phone"
            :rules="[{ required: true, message: '请输入日常联系人电话' }]"
            error-message-align="right"
            label="联系人电话"
            rows="1"
            autosize
            type="textarea"
            input-align="right"
            clearable
            placeholder="请输入日常联系人电话"
        />

                        <van-field
                                v-model="formData.phonecode"
                                label="验证码"
                                :rules="[{ required: true,message:'请输入验证码'}]"
                                error-message-align="right"
                                input-align="right"
                                clearable
                                placeholder="请输入验证码"
                        >
                        <template #button>
                        <van-button @click="getCode" native-type="button" size="small" type="primary" :disabled="clockSecond>0">{{clockSecond>0?
                    '('+clockSecond+'s)':'获取验证码'}}</van-button>
                        </template>
                        </van-field>




        <van-field
            v-model="formData.address_wuliao"
            error-message-align="right"
            label="考级物料收货地址"
            input-align="right"
            clearable
            placeholder="请输入考级物料收货地址"
        />

        <!--              <van-field-->
        <!--                  v-model="formData.kaojiyaoqiu"-->
        <!--                  :rules="[{ required: true, message: '请输入考级要求' }]"-->
        <!--                  error-message-align="right"-->
        <!--                  label="考级要求"-->
        <!--                  rows="1"-->
        <!--                  autosize-->
        <!--                  type="textarea"-->
        <!--                  input-align="right"-->
        <!--                  clearable-->
        <!--                  placeholder="请输入考级要求"-->
        <!--              />-->
        <!--        <van-field-->
        <!--            v-model="formData.zhuyishixiang"-->
        <!--            :rules="[{ required: true, message: '请输入特殊说明' }]"-->
        <!--            error-message-align="right"-->
        <!--            label="特殊说明"-->
        <!--            rows="1"-->
        <!--            autosize-->
        <!--            type="textarea"-->
        <!--            input-align="right"-->
        <!--            clearable-->
        <!--            placeholder="请输入特殊说明"-->
        <!--        />-->
        <!--        <div class="operate-desc-left">成套形式和分段形式</div>-->

      </van-cell-group>

      <div class="savebtn">
        <van-button
            color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
            style="width: 3rem"
            size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..." @click="submit">保存
        </van-button>
      </div>
    </van-form>
    <KaoguanPicker
        :show="showKaoguanPicker"
        :limit="1"
        :grade="grade"
        @onChange="onKaoguanChange"
        @onClose="showKaoguanPicker=false"
        :defaultValue="formData.jigoukaoguan"
        @onConfirm="onKaoguanConfirm"
    ></KaoguanPicker>
    <!--    <KaoguanPicker-->
    <!--        :show="showKaoguanPicker"-->
    <!--        :limit="6"-->
    <!--        @onChange="onKaoguanChange"-->
    <!--        @onClose="showKaoguanPicker=false"-->
    <!--        :defaultValue="formData.jigou"-->
    <!--        @onConfirm="onKaoguanConfirm"-->
    <!--    ></KaoguanPicker>-->
    <JianduPicker
        :show="showJianduPicker"
        :limit="1"
        @onChange="onJianduChange"
        @onClose="showJianduPicker=false"
        :defaultValue="formData.jiandu"
        @onConfirm="onJianduConfirm"
    ></JianduPicker>
    <CenterPicker
        :show="showCenterPicker"
        :limit="1"
        @onChange="onCenterChange"
        @onClose="showCenterPicker=false"
        :defaultValue="formData.extra_center"
        @onConfirm="onCenterConfirm"
    ></CenterPicker>
    <van-popup v-model="showDate" position="bottom">
      <van-datetime-picker
          @cancel="showDate =false"
          title="选择年月日"
          type="date"
          :default-date='new Date( (formData.datetitle? formData.datetitle :"" ).replace(/-/g,"/") )'
          :min-date="minDate"
          @confirm="onDateConfirm"/>
    </van-popup>


    <van-popup v-model="showBaomimgPicker" position="bottom">
      <van-picker :columns="saiBaomingOptions"
                  show-toolbar
                  title="报名记录选择"
                  @cancel="showBaomimgPicker = false"
                  @confirm="onBaomingConfirm"
      />
    </van-popup>


    <van-popup v-model="showBaomimgSubjectPicker" position="bottom">
      <van-picker :columns="saiBaomingSubjectOptions"
                  show-toolbar
                  title="报名记录选择"
                  @cancel="showBaomimgSubjectPicker = false"
                  @confirm="onBaomingSubjectConfirm"
      />
    </van-popup>
  </div>
</template>
<style scoped>
.box {
  /*margin-bottom: 1.5rem;*/
}

.small-button {
  height: 30px;
  padding: 0 8px;
  font-size: 12px;
  line-height: 28px;
  color: #323233;
  background-color: #fff;
  border: 1px solid #ebedf0;
}

.kaoguan-box .van-tag {
  margin-bottom: .1rem;
}


.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}


.van-tag {
  margin-left: 10px;
}

.between {
  justify-content: space-between;
}


</style>
<script>
import Vue from 'vue';
import area from "../../../utils/area";
import validator from "../../../utils/validator";
import PicUploader from '@/components/picker/PicUploader.vue';
import KaoguanPicker from '@/components/picker/KaoguanPicker.vue';
import JianduPicker from '@/components/picker/JianduPicker.vue';
import CenterPicker from '@/components/picker/CenterPicker.vue';

import {
  Cell,
  Field,
  Area,
  DatetimePicker,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  Icon,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button,
  Calendar
} from 'vant';

Vue.use(Cell).use(CellGroup).use(DatetimePicker).use(Calendar).use(Form).use(Divider).use(Area).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
    .use(Switch).use(Button);
export default {
  name: 'StationApply',
  components: {
    PicUploader,
    KaoguanPicker,
    JianduPicker,
    CenterPicker,
  },
  data: function () {
    return {
      validator,
      showBaomimgPicker:false,
      saiBaomingOptions:[],
      saiBaomingMap:[],
      showBaomimgSubjectPicker:false,
      saiBaomingSubjectOptions:[],
      showDate: false,
      showKaoguanPicker: false,
      showCenterPicker: false,
      showJianduPicker: false,
      clockSecond:0,
      saveLoading: false,
      showArea: false,
      areaList: {},
      areaValue: '',
      submitType: '',
      row: {},
      centerRow: {},
      starList: [{id: 11, text: '幼儿初级(2022版)'}, 
      {id: 12, text: '幼儿中级(2022版)'}, 
      {id: 13, text: '幼儿高级(2022版)'}, 
      {id: 14, text: '红规定动作(2022版)'}, 
      {
        id: 15,
        text: '橙规定动作(2022版)'
      }, 
      {id: 16, text: '黄规定动作(2022版)'},  

      {id: 17, text: '红规定动作(2016版)'}, 
      {
        id: 18,
        text: '橙规定动作(2016版)'
      }, 
      {id: 19, text: '黄规定动作(2016版)'},  
      ],
      minDate: new Date(new Date(new Date().toLocaleDateString()).getTime() + 3600 * 24 * 15 * 1000), //15天后
      formData: {
        id: 0,
        danwei:'',
        sai_baoming_id:0,
        sai_baoming_name:'',
        sai_baoming_subject_id:0,
        sai_baoming_subject_name:'',
        datetitle: '',
        areas: '',
        jigoukaoguan: [],
        kaoguan: [],
        jiandu: [],
        extra_center: [],
        star_type: [],
        province: '',
        city: '',
        county: '',
        address_wuliao: ''
      },

      grade: '',
      jianduList: [],
      kaoguanList: [],
      kaoguanWaitList: []
    }
  },
  filters: {},
  mounted() {
    let that = this;
    that.areaList = area;
    document.title = '申报星级'
    that.formData.id = this.$route.query.id || 0;
    if (that.formData.id) {
      // this.fetch();
      this.getCenterDetail()
    }
    this.getSetting();
    this.getSaiBaomingOptions();
  },
  watch: {
    formData() {
    }
  },
  destroyed() {
  },
  methods: {
    onQuestion() {
      console.log('onQuestion')
    },
    onDateConfirm(date) {
      console.log('onDateConfirm', date);
      this.showDate = false;
      // this.formData.datetitle =  `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()} ${date.getHours()}:${date.getMinutes()}`
      this.formData.datetitle = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
    },

    onBaomingConfirm(value,index){
      console.log('onBaomingConfirm',value,index)
      this.saiBaomingSubjectOptions = this.saiBaomingMap[index].subject.map(item =>{
        return item.subject_name
      });
      this.formData.sai_baoming_id = this.saiBaomingMap[index].id;
      this.formData.sai_baoming_name = this.saiBaomingMap[index].mingcheng;
      this.showBaomimgPicker=false;
    },
    onBaomingSubjectConfirm(value,index){
      this.saiBaomingMap.map(item =>{
        if(item.id == this.formData.sai_baoming_id ){
          this.formData.sai_baoming_subject_id  = item.subject[index].id;
          return ;
        }
      })
      this.formData.sai_baoming_subject_name = value;
      this.showBaomimgSubjectPicker=false;
    },
    getSaiBaomingOptions(){
      let that = this;
      that.$api.post('/api/sai/baomingsubjectoptions', {
      }, (res) => { 
        console.log(res);
        that.saiBaomingMap = res.data;
        that.saiBaomingOptions = res.data.map(item =>{
          return item.mingcheng
        })
      }, (res) => {
        Toast.fail(res.msg);
      })
    },

    onKaoguanShow() {
      let that = this,
      startList = that.formData.star_type,
      gradeList = []
      startList.map(type => {
        gradeList.push(type.text)
      })

      if (!gradeList.length) {
        Toast("请先选择考试星级")
        return
      }

      // 增加星级筛选
      this.grade = that.getGrade(gradeList)
      this.showKaoguanPicker = true
    },
    getKaoguanRand() {
      let that = this,
          startList = that.formData.star_type,
          gradeList = []
      startList.map(type => {
        gradeList.push(type.text)
      })
      if (that.kaoguanList.length > 0) {
        that.getKaoguanValue()
        return
      }
      // console.log(gradeList,gradeList.indexOf('青星级'))

      if (!gradeList.length) {
        Toast("请先选择考试星级")
        return
      }

      // 增加星级筛选
      let grade = that.getGrade(gradeList)

      that.$api.post('/api/kaoguan/optionsRand', {
        center_id: that.$route.query.id,
        limit: 9,
        grade: grade
      }, (res) => {
        if (!res.data.length) {
          Toast('没有相关等级的考官')
        }
        that.kaoguanList = res.data
        that.getKaoguanValue()
      }, (res) => {
        Toast.fail(res.msg);
      })
    },

    getGrade(gradeList) {
      let grade = ''
      if (gradeList.indexOf('蓝星级') >= 0 || gradeList.indexOf('紫星级') >= 0) {
        grade = '高级'
      } else if (gradeList.indexOf('绿星级') >= 0 || gradeList.indexOf('青星级') >= 0) {
        grade = '中级高级'
      }
      return grade;
    },
    getJianduRand() {
      let that = this
      // formData.jiandu 有值，从数组中随机筛选
      if (that.jianduList.length > 0) {
        that.getJianduValue()
        return
      }

      that.$api.post('/api/jiandu/optionsRand', {
        center_id: that.$route.query.id,
        limit: 3
      }, (res) => {
        that.jianduList = res.data

        that.getJianduValue()
      }, (res) => {
        Toast.fail(res.msg);
      })
    },

    getKaoguanValue() {
      let that = this,
          kaoguan = that.kaoguanWaitList,
          kaoguanList = []
      // that.kaoguanList.map(row => {
      //   kaoguan.map(value => {
      //     if(row.id != value.id) {
      //       kaoguanList.push(row)
      //     }
      //   })
      // })

      kaoguanList = [...that.kaoguanList].filter(x => [...kaoguan].every(y => y.id !== x.id))
      console.log('kaoguanList', kaoguanList)

      if (!kaoguan.length) {
        kaoguanList = that.kaoguanList
      }

      // let length = kaoguan.length >= 3 ? 0 : 3 - kaoguan.length;
      let length = 3;
      let kaoguanValue = that.getRandomArr(kaoguanList, length)

      if (!kaoguanValue.length) return
      that.kaoguanWaitList = kaoguanValue
      console.log(that.formData.kaoguan, that.kaoguanList, length)
    },

    // 选择考官
    onKaoguanChoose(kaoguan) {
      let count = 0
      this.formData.kaoguan.map(row => {
        if (row.id == kaoguan.id) {
          Toast(kaoguan.name + ' 考官已选择')
          count++
        }
      })
      if (count) return
      this.formData.kaoguan.push(kaoguan)
    },

    getJianduValue() {
      let that = this,
          jiandu = that.formData.jiandu,
          jianduList = []

      if (!that.jianduList.length) {
        that.formData.jiandu = []
        Toast.fail('暂无所属地区监督人员数据')
        return
      }

      that.jianduList.map(row => {
        jiandu.map(value => {
          if (row.id != value.id) {
            jianduList.push(row)
          }
        })
      })

      if (!jiandu.length) {
        jianduList = that.jianduList
      }

      // console.log(jianduList[Math.floor(Math.random()*jianduList.length)])

      // let jiandu = [jianduList[Math.floor(Math.random()*jianduList.length)]]
      let jianduValue = that.getRandomArr(jianduList, 1)

      that.formData.jiandu = jianduValue
      console.log(jianduList)
    },

    getRandomArr(arr, count) {//随机抽取
      var shuffled = arr.slice(0), i = arr.length, min = i - count, temp, index;
      while (i-- > min) {//打乱数组
        index = Math.floor((i + 1) * Math.random());
        temp = shuffled[index];
        shuffled[index] = shuffled[i];
        shuffled[i] = temp;
      }
      return shuffled.slice(min);
    },

    onKaoguanConfirm(values) {
      console.log('onKaoguanConfirm', values)
      this.showKaoguanPicker = false;
      this.formData.jigoukaoguan = [...values];
    },
    onKaoguanChange(values) {
      console.log('onKaoguanChange', values)
      this.formData.jigoukaoguan = [...values];
    },
    onJianduConfirm(values) {
      console.log('onJianduConfirm', values)
      this.showJianduPicker = false;
      this.formData.jiandu = [...values];
    },
    onJianduChange(values) {
      console.log('onJianduChange', values)
      this.formData.jiandu = [...values];
    },
    onCenterChange(values) {
      console.log('onCenterChange', values)
      this.formData.extra_center = [...values];
    },
    onCenterConfirm(values) {
      console.log('onJianduConfirm', values)
      this.showCenterPicker = false;
      this.formData.extra_center = [...values];
    },
    onAreaConfirm(values) {
      console.log(values);
      this.formData.area = values[2].code;
      this.formData.province = values[0].name;
      this.formData.city = values[1].name;
      this.formData.county = values[2].name;
      this.showArea = false;
    },
    onSubmit(values) {
      console.log('onSubmit-values', values);
      console.log('submitType', this.submitType);

      let that = this;
      console.log(that.formData)
      that.formValidate = true;

      // 绿色星级及以上必须选择考级中心
      let isGreenUp = false
      this.formData.star_type.map(star => {
        if (star.id >= 4) {
          isGreenUp = true
        }
      })
      console.log(that.formData.extra_center)
      // return
      // if(isGreenUp && !that.formData.extra_center.length) {
      //   Toast('考级点如需申报绿星级及以上星级的考级，请选择考级中心')
      //   return
      // }

      for (let field in that.formData) {
        if (!this.formData.star_type.length) {
          Toast('请选择星级');
          return
        }

        if (!this.formData.area) {
          Toast('请选择地区');
          return
        }
        if (!this.formData.jiandu.length) {
          // Toast('请选择监督');
          // return
          // this.formData.jiandu = []
        }
        if(!this.formData.kaoguan.length) {
          // Toast('请选择非机构考官');
          // return
        }
        // 考官总数 不少于2个
        // if ((this.formData.kaoguan.length + this.formData.jigoukaoguan.length) < 2) {
        //   Toast('至少选择2个考官');
        //   return
        // }
        // 改成需要 是2的倍数
        if ((this.formData.kaoguan.length + this.formData.jigoukaoguan.length) % 2 !=0 ) {
          // Toast('机构考官+非机构考官总数必须是双数');
          // return
        }
      }
      that.saveLoading = true;

      if (that.submitType == 'save') {
        that.$api.post('/api/qcxj/kaojiApplySave', that.formData, (res) => {
          that.saveLoading = false;
        }, (res) => {
          Toast.fail(res.msg);
          that.saveLoading = false;
        })
      } else {
        that.$api.post('/api/qcxj/kaojiApplyAddSai', that.formData, (res) => {
          that.saveLoading = false;

          if (!this.formData.jiandu.length) {
            // Toast('请选择监督');
            // return
            Toast.fail("你没有选择监督 请联系工作人员")
            setTimeout(function () {
              rbLink({
                'name': 'ExameApplyDetailMine',
                'query': {
                  id: res.data.id
                }
              }, 'back')
            }, 1000)
          } else {
            rbLink({
              'name': 'ExameApplyDetailMine',
              'query': {
                id: res.data.id
              }
            }, 'back')
          }

        }, (res) => {
          Toast.fail(res.msg);
          that.saveLoading = false;
        })
      }
    },
    save(values) {
      this.submitType = 'save';
    },
    onFailed(errorInfo) {
      console.log('failed', errorInfo, this.formData);
    },
    submit(values) {
      this.submitType = 'submit';
    },
    fetch() {
      let that = this;
      that.$api.post('/api/qcxj/applydetail', {
        id: that.formData.id
      }, (res) => {
        that.formData = res.data;
      }, (res) => {
        Toast.fail(res.msg);
      })
    },
    getCenterDetail() {
      let that = this;
      that.$api.post('/api/examecenter/centerdetail', {
        id: that.formData.id,
      }, (res) => {
        that.centerRow = res.data;
      }, (res) => {
//                    Toast.fail(res.msg);
      })
    },
    getSetting() {
      let that = this;
      that.$api.post('/api/qcxj/getSetting', {}, (res) => {
        that.row = res.data;
        that.formData.danwei = res.data.center.danwei
      }, (res) => {
        Toast.fail(res.msg);
      })
    },

    getCode() {
        let that = this;
        if (that.clockSecond > 0) {
            return;
        }
        if (!that.formData.phone) {
            Toast('请输入手机号')
            return;
        }
        /*if (!that.formData.code) {
            Toast('请输入验证码')
            return;
        }*/
        that.$api.get('/api/index/phonecode', {phone: that.formData.phone}, (res) => {
            Toast(res.msg);
        })

        that.clockSecond = 60;

        var t = setInterval(function () {
            if (that.clockSecond > 0) {
                that.clockSecond = that.clockSecond - 1;
            } else {
                clearInterval(t);
            }
        }, 1000)
    },

  }
}
</script>
<style scoped>
.gray-back >>> .van-cell__value{
  color: #000 !important;
}
</style>


// WEBPACK FOOTER //
// ExameApplyFormSaiMine.vue?355cb8d2